module.exports = __webpack_public_path__ + "img/service-resource09.18180302.jpg";